import { Outlet, useParams } from 'react-router-dom'

import { AvailableModules } from 'generated/featureDefinitions'
import {
  GetModuleAvailabilitiesDocument,
  TrainingDetailPageDocument,
} from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import { isModuleAvailabilityEnabled } from 'modules/core/lib/isModuleAvailabilityEnabled'

const DetailRevamp = () => {
  const { id } = useParams()
  const {
    company: { id: companyId },
  } = useCurrentSession()
  const { data } = useQuery(TrainingDetailPageDocument, {
    variables: {
      trainingId: Number(id),
      resourceId: String(id),
      companyId,
    },
    fetchPolicy: 'cache-only',
  })

  const training = data?.trainings.training
  const trainingClasses = training?.trainingClassesConnection.nodes
  const canEdit = Boolean(training?._policies?.edit.can)
  const hasDevTrainings = Boolean(
    data?.features.featuresConnection.nodes.find(
      (n) => n.name === 'dev_trainings' && n.enabled == true
    )
  )

  const hasLMSDevFeatureFlag = Boolean(
    data?.features.featuresConnection.nodes.find(
      (n) => n.name === 'dev_training_lms' && n.enabled === true
    )
  )

  const { data: featureData } = useQuery(GetModuleAvailabilitiesDocument, {
    fetchPolicy: 'cache-first',
    variables: {
      ids: [AvailableModules.lms],
      companyId,
    },
  })

  const moduleAvailabilities = featureData?.companies.moduleAvailabilities ?? []
  const hasLMSModule = isModuleAvailabilityEnabled(moduleAvailabilities, AvailableModules.lms)

  const hasContentFF = hasLMSModule || hasLMSDevFeatureFlag

  return (
    <Outlet
      context={{
        scores: data?.forms.scores,
        classes: trainingClasses,
        training,
        competencies: training?.competenciesConnection.nodes,
        canEdit,
        hasDevTrainings,
        hasContentFF,
      }}
    />
  )
}

export default DetailRevamp
